import React from 'react';
import { ReactComponent as FigCoinsHandComponent } from './FigCreditCardPlus.svg';

const FigCreditCardPlus = (props) => <FigCoinsHandComponent {...props} />;

export default FigCreditCardPlus;
